exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\r\n  /* border: 0 solid #e1e1e1;\r\n  border-bottom-width: 1px;\r\n  display: block;\r\n  height: 48px;\r\n  padding: 0 16px; */\r\n\r\n  height: 55px;\r\n  background-color: #fff;\r\n  border-bottom: 1px solid #c2cfd6;\r\n}\r\n\r\nnav a {\r\n  color: #8f8f8f;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  line-height: 48px;\r\n  margin-right: 20px;\r\n  text-decoration: none;\r\n  vertical-align: middle;\r\n  cursor: pointer;\r\n}\r\n\r\nnav a.router-link-active {\r\n  color: #106cc8;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /ng-app/src/app/shared/navbar/navbar.component.css
// module id = ../../../../../src/app/shared/navbar/navbar.component.css
// module chunks = main